import React from 'react';
import { connect, } from 'react-redux'
import { bindActionCreators } from 'redux'

import { actions as rootActions } from '../actions'
import { NAME as ROOT_NAME } from '../reducer'
import { HashRouter as Router, Route, Switch, Redirect } from "react-router-dom"
import { createBrowserHistory } from "history"

import ResponsiveDrawer from "../../../components/ResponsiveDrawer"
import SideMonitor from '../../Monitor/container/SideMonitor'
import MonitorList from '../../Monitor/container/MonitorList'
import CreateMonitor from '../../Monitor/container/CreateMonitor'
import ProductTypeList from '../../ProductType/container/ProductTypeList'
import CreateProductType from '../../ProductType/container/CreateProductType'
import CompanyList from '../../Companies/container/CompanyList'
import CreateCompany from '../../Companies/container/CreateCompany'
import CompanyPage from '../../Companies/container/CompanyPage'
import CreateProduct from '../../Product/container/CreateProduct'
import {CustomRedirection} from '../../../components/CustomRedirection'
import LeaveDialog from '../../../components/LeaveDialog'
import ScrollToTop from '../../../components/ScrollToTop'
import { askToLeave } from '../../../components/leaveGuard'
import EditCompany from '../../Companies/container/EditCompany';
import CreateBroadcast from '../../Whatsapp/container/CreateBroadcast'
import BroadcastLists from '../../Whatsapp/container/BroadcastLists'
import Account from '../../Whatsapp/container/Account'
import History from '../../Whatsapp/container/History'
import Statistics from '../../Whatsapp/container/Statistics'
import Templates from '../../Whatsapp/container/Templates'
import Messages from '../../Whatsapp/container/Messages'
import PlatformShell, { PageTitle } from '../../Whatsapp/components/PlatformShell'

const hist = createBrowserHistory()

function mapStateToProps(state) {
    return {
        ...state[ROOT_NAME]
    }
}


const mapDispatchToProps = (dispatch) => bindActionCreators({
    ...rootActions,
}, dispatch)


class Root extends React.Component {
    constructor(props) {
        super(props);        
    }
    render() {
      return(
          <Router history={hist} getUserConfirmation={askToLeave}>
            <LeaveDialog />
            <ScrollToTop />
            <Switch>
              {this.props.redirect && <CustomRedirection redirectTo={this.props.redirect} reset={this.props.resetRedirect}/>}              
              <Route
                        path='/createmonitor'
                        exec='/createmonitor'
                        key='/createmonitor'
                      >                        
                 <ResponsiveDrawer
                 hideAlert = {this.props.hideAlert}
                 alert = {this.props.alert}
                 Monitor = {SideMonitor}
                 MainContent = {CreateMonitor}/>
              </Route>
              <Route
                        path='/listmonitor'
                        exec='/listmonitor'
                        key='/listmonitor'
                      >                        
                 <ResponsiveDrawer
                 hideAlert = {this.props.hideAlert}
                 alert = {this.props.alert}
                 Monitor = {SideMonitor}
                 MainContent = {MonitorList}/>
              </Route>              
              <Route
                        path='/producttypelist'
                        exec='/producttypelist'
                        key='/producttypelist'
                      >                        
                 <ResponsiveDrawer
                 hideAlert = {this.props.hideAlert}
                 alert = {this.props.alert}
                 Monitor = {SideMonitor}
                 MainContent = {ProductTypeList}/>
              </Route>
              <Route
                        path='/createproducttype'
                        exec='/createproducttype'
                        key='/createproducttype'
                      >                        
                 <ResponsiveDrawer
                 hideAlert = {this.props.hideAlert}
                 alert = {this.props.alert}
                 Monitor = {SideMonitor}
                 MainContent = {CreateProductType}/>
              </Route>
              <Route
                        path='/companylist'
                        exec='/companylist'
                        key='/companylist'
                      >                        
                 <ResponsiveDrawer
                 hideAlert = {this.props.hideAlert}
                 alert = {this.props.alert}
                 Monitor = {SideMonitor}
                 MainContent = {CompanyList}/>
              </Route>
              <Route
                        path='/createcompany'
                        exec='/createcompany'
                        key='/createcompany'
                      >                        
                 <ResponsiveDrawer
                 hideAlert = {this.props.hideAlert}
                 alert = {this.props.alert}
                 Monitor = {SideMonitor}
                 MainContent = {CreateCompany}/>
              </Route>
              <Route
                        path='/companypage'
                        exec='/companypage'
                        key='/companypage'
                      >                        
                 <ResponsiveDrawer
                 hideAlert = {this.props.hideAlert}
                 alert = {this.props.alert}
                 Monitor = {SideMonitor}
                 MainContent = {CompanyPage}/>
              </Route>
              <Route
                        path='/editcompany'
                        exec='/editcompany'
                        key='/editcompany'
                      >                        
                 <ResponsiveDrawer
                 hideAlert = {this.props.hideAlert}
                 alert = {this.props.alert}
                 Monitor = {SideMonitor}
                 MainContent = {EditCompany}/>
              </Route>              
              <Route
                        path='/createproduct'
                        exec='/createproduct'
                        key='/createproduct'
                      >                        
                 <ResponsiveDrawer
                 hideAlert = {this.props.hideAlert}
                 alert = {this.props.alert}
                 Monitor = {SideMonitor}
                 MainContent = {CreateProduct}/>
              </Route>
              {/* Дашборда больше нет: старые закладки ведут на статистику. */}
              <Redirect from='/whatsappdashboard' to='/whatsappstats'/>
              <Route
                        path='/whatsapphistory'
                        exact
                        key='/whatsapphistory'
                      >
                 <PlatformShell active='history' alert={this.props.alert} hideAlert={this.props.hideAlert}>
                   <History/>
                 </PlatformShell>
              </Route>
              <Route
                        path='/whatsappaccount'
                        exact
                        key='/whatsappaccount'
                      >
                 <PlatformShell active='account' alert={this.props.alert} hideAlert={this.props.hideAlert}>
                   <PageTitle kicker='АККАУНТ' title='Аккаунт WhatsApp' subtitle='Как Meta видит ваш номер, сколько можно написать сегодня и что видят клиенты'/>
                   <Account/>
                 </PlatformShell>
              </Route>
              <Route
                        path='/whatsappstats'
                        exact
                        key='/whatsappstats'
                      >
                 <PlatformShell active='stats' alert={this.props.alert} hideAlert={this.props.hideAlert}>
                   <PageTitle kicker='СТАТИСТИКА' title='Статистика рассылок' subtitle='Что отправлено, дошло ли оно и как отвечают клиенты'/>
                   <Statistics/>
                 </PlatformShell>
              </Route>
              <Route
                        path='/whatsapplists'
                        exact
                        key='/whatsapplists'
                      >
                 <PlatformShell active='lists' alert={this.props.alert} hideAlert={this.props.hideAlert}>
                   <PageTitle kicker='СПИСКИ' title='Списки рассылки'/>
                   <BroadcastLists/>
                 </PlatformShell>
              </Route>
              <Route
                        path='/whatsappmessages'
                        exact
                        key='/whatsappmessages'
                      >
                 <PlatformShell active='messages' alert={this.props.alert} hideAlert={this.props.hideAlert}>
                   <PageTitle kicker='СООБЩЕНИЯ' title='Ответы клиентов' subtitle='Переписки по рассылкам: что отправлено и что ответили клиенты'/>
                   <Messages/>
                 </PlatformShell>
              </Route>
              <Route
                        path='/whatsapptemplates'
                        exact
                        key='/whatsapptemplates'
                      >
                 <PlatformShell active='templates' alert={this.props.alert} hideAlert={this.props.hideAlert}>
                   <PageTitle kicker='ШАБЛОНЫ' title='Шаблоны сообщений' subtitle='Рассылки WhatsApp идут только по шаблонам, одобренным Meta'/>
                   <Templates/>
                 </PlatformShell>
              </Route>
              <Route
                        path='/whatsapp'
                        exact
                        key='/whatsapp'
                      >
                 <PlatformShell active='broadcast' alert={this.props.alert} hideAlert={this.props.hideAlert}>
                   <PageTitle kicker='РАССЫЛКИ' title='Рассылка в WhatsApp' subtitle='Сообщение получат только контакты, давшие согласие на рассылку'/>
                   <CreateBroadcast/>
                 </PlatformShell>
              </Route>
              <Route
                        path='/'
                        exec='/'
                        key='lala'
                      >                        
                 <Redirect to="/companylist"/>
              </Route>
            </Switch>
          </Router>
      )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Root)
